// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { store, EventBus } from "./store/index";
import { Helper } from "./helpers";

Vue.config.productionTip = false;

const elem = document.getElementById("product-configurator");
let init = false;
let data = {};
for (let [key, value] of Object.entries(elem.dataset)) {
	data[key] = value;
}
data["productFrontId"] = elem.dataset.productFrontId.split(",");
data["specifications"] = window.__cms_specifications;

const targetElement = JSON.parse(JSON.stringify(data)); // for the productdata from html
const addClass = (element, className) => {
	const elements = Array.from(document.querySelectorAll(element));
	elements.forEach(item => {
		item.classList.add(className);
	});
};

const removeClass = (element, className) => {
	const elements = Array.from(document.querySelectorAll(element));
	elements.forEach(item => {
		item.classList.remove(className);
	});
};

if (!Element.prototype.closest) {
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	Element.prototype.closest = function (s) {
		var el = this;
		var ancestor = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (ancestor.matches(s)) return ancestor;
			ancestor = ancestor.parentElement;
		} while (ancestor !== null);
		return null;
	};
}

function addDelegatedListener (elem, event, callback) {
	document.addEventListener(event, function (e) {
		var element = e.target;
		if (element.closest(elem)) {
			// Found a `td` within the container!
			if (typeof callback === "function") {
				callback();
			}
		}
	});
}

function getUrlParameter (name) {
	// eslint-disable-next-line no-useless-escape
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
	var results = regex.exec(location.search);
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/* eslint-disable no-new */

addDelegatedListener("#upload-button", "click", function () {
	initApp("upload");
});
addDelegatedListener("#calculate-button", "click", function () {
	initApp("calculate");
});
addDelegatedListener(".upload-button", "click", function () {
	initApp("upload");
});
addDelegatedListener(".calculate-button", "click", function () {
	initApp("calculate");
});

if (targetElement.configId !== "null") {
	initApp("configuration");
} else {
	initApp("calculate");
}

function initApp (type) {
	if (type !== store.getters.getConfiguratorTypeString) {
		if (!store.getters.checkData.hasSelectedOptions) {
			store.commit("SET_CONFIGURATOR_TYPE", type);
		} else {
			EventBus.$emit("scrollToStep");
		}
	}

	if (init) {
		EventBus.$emit("scrollToStep");
	}

	if (init === false) {
		new Vue({
			el: "#product-configurator",
			components: { App },
			template: "<App/>",
			store: store,
			data: {
				isLoaded: false
			},
			computed: {
				hasSelectedOptions () {
					return store.getters.checkData.hasSelectedOptions;
				},
				isOffTheShelf () {
					return this.$store.getters.isOffTheShelf;
				}
			},
			mounted: function () {
				const configuratorHolder = this.$el;

				const measureBounds = () => {
					const rect = configuratorHolder.getBoundingClientRect();
					const left = Math.max(rect.left, 0);
					const right = Math.min(rect.right, window.innerWidth);
					return {
						top: rect.top,
						bottom: rect.bottom,
						left,
						right,
						width: right - left,
						height: rect.height,
						x: left,
						y: rect.top
					};
				};

				Helper.optimizedResize(function () {
					store.commit("SET_BOUNDING_RECT", measureBounds());
					store.commit("SET_VIEWPORT_INFO", window.innerWidth);
				});

				store.commit("SET_BOUNDING_RECT", measureBounds());
				store.commit("SET_VIEWPORT_INFO", window.innerWidth);
			},
			created: function () {
				this.$store.commit("SET_BASE_PROPS", targetElement);

				const specificationId = getUrlParameter("s");
				if (specificationId) {
					this.$store.commit("SET_IS_SPECIFICATION_CONFIGURATION", true);
					this.$store.commit("SET_SPECIFICATION_ID", parseInt(specificationId));

					const quantity = getUrlParameter("q");
					if (quantity) {
						this.$store.commit("SET_PRESELECTED_QUANTITY", parseInt(quantity));
					}
				}

				this.$store.dispatch("_SetProductData");
			},
			methods: {},
			watch: {
				hasSelectedOptions: (a, b) => {
					if (a) {
						["#upload-button", "#calculate-button", ".upload-button", ".calculate-button"]
							.forEach(item => addClass(item, "button--opaque"));
					}
				},
				isOffTheShelf: (a, b) => {
					if (a) {
						["#upload-button", ".upload-button"]
							.forEach(item => addClass(item, "hide"));
					} else {
						["#upload-button", ".upload-button"]
							.forEach(item => removeClass(item, "hide"));
					}
				}
			}
		});
		init = true;
	}
}



// WEBPACK FOOTER //
// ./src/main.js